import styled, { css } from 'styled-components';
import { MarkdownContainer } from 'globalStyles/CardDetails';
import { WrapperProps } from './types';
import { Column, Row } from 'globalStyles/Containers';

export const Fluid = styled.div`
  width: 100%;
  height: auto;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`;

export const Main = styled(Fluid)`
  display: flex;
  flex-direction: column;
  gap: 72px;
  padding: 32px 80px 72px;

  .home-unavailability-banner {
    margin-bottom: 16px;
  }

  iframe {
    width: 50%;
    min-height: 374px;
  }
`;
export const MainRow = styled(Row)`
  flex-grow: 1;
  > * {
    flex: 1;
    height: 100%;
  }
  button {
    width: fit-content;
  }
`;

export const TitleStyles = css`
  font-size: 48px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 0;
  color: ${({ theme }) => theme.textPrimary};
`;

export const SecondaryTitleStyles = css`
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: ${({ theme }) => theme.textPrimary};
`;

export const DescriptionStyles = css`
  margin: 16px 0 0 0;
  font-size: 24px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 150%;
  letter-spacing: normal;
  color: ${({ theme }) => theme.textPrimary};
`;

export const ImageContainer = styled.div`
  background-image: url('${(props: WrapperProps) => props.backgroundImage}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  resize: both;
`;

export const MarkdownTitleContainerCaseOpening = styled(MarkdownContainer)`
  h1 {
    ${TitleStyles}
  }

  p {
    ${DescriptionStyles}
  }
`;
export const MarkdownContainerCaseOpening = styled(MarkdownContainer)`
  h1 {
    ${SecondaryTitleStyles}
  }

  p {
    ${DescriptionStyles}
  }
`;

export const MarkdownSecondaryContainerCaseOpening = styled(
  MarkdownContainerCaseOpening,
)`
  width: 50%;
`;

export const RetractableRow = styled(Column)`
  @media (min-width: 1440px) {
    flex-direction: row;
  }
`;

export const FAQContainer = styled.div`
  max-width: 820px;
  width: 100%;
  align-self: center;
  > div:first-child {
    margin-bottom: 32px;
  }
`;
